// extracted by mini-css-extract-plugin
export var body = "_24-8";
export var button = "_24-0";
export var closeButton = "_24-5";
export var content = "_24-3";
export var empty = "_24-f";
export var grid = "_24-c";
export var header = "_24-4";
export var icon = "_24-1";
export var option = "_24-d";
export var optionSelected = "_24-e";
export var overlay = "_24-2";
export var searchIcon = "_24-a";
export var searchInput = "_24-b";
export var searchWrapper = "_24-9";
export var title = "_24-6";
export var visuallyHidden = "_24-7";